<div class="workflow-container" [ngClass]="{'workflow-small': small}">
	<div class="workflow justify-content-center">
		<div class="workflow-items">
			<div class="workflow-track"></div>
		    <ng-container *ngFor="let step of workflowStages; let i = index">
		    
		    <div class="workflow-item" [title]="getUsers(step)">
			      	<span  class="workflow-item-badge" [ngClass]="{
						'awaiting': step.statusId == workflowStageDataStatus.NotStarted,
						'active': step.statusId == workflowStageDataStatus.InProgress,
						'rejected': step.statusId == workflowStageDataStatus.Rejected,
						'completed': step.statusId == workflowStageDataStatus.Complete
					}">
						<i class="workflow-item-icon"></i>
					</span>
			      	<span class="workflow-item-text">
			      		{{step.name}}
			      	</span>
				</div>   
			</ng-container>
		</div> 
		<div class="workflow-summary text-muted">
			<em>{{currentStage?.name}}</em>
		</div>
	</div>
</div>

